import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ForgotPasswordModal from "./ForgotPassword"; // Ensure this is the correct path
import { BASE_URL } from "./Config";
import { FiEye, FiEyeOff } from "react-icons/fi";


export default function AdminLogin() {
  const [credentials, setCredentials] = useState({
    user_name: "",
    password: "",
  });
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [showForgotModal, setShowForgotModal] = useState(false); // modal control


  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prev) => ({ ...prev, [name]: value }));
  };

  const handleForgotPassword = () => {
    setShowForgotModal(true);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");

    try {
      const response = await fetch(
       `${BASE_URL}/api/admin/admin_login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(credentials),
        }
      );

      const data = await response.json();
      console.log("Admin login response:", data);

      if (response.ok) {
        const token =
          data.token || data.accessToken || data.access_token || (data.data && data.data.token);

        if (token) {
          localStorage.setItem("admin_token", token);
          setStatus("✅ Admin login successful!");
          navigate("/AdminDashboard");
        } else {
          setStatus("Login failed: No token received.");
          console.warn("Token missing in admin login response:", data);
        }
      } else {
        setStatus(data.message || "Invalid admin credentials.");
      }
    } catch (error) {
      console.error("Login error:", error);
      setStatus("Network or server error.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      <form 
        onSubmit={handleLogin} 
        className="w-full max-w-md mx-auto admin-login-form-responsive"
        style={
          window.innerWidth <= 600
            ? {
                padding: '0.7rem',
                maxWidth: '98vw',
                boxSizing: 'border-box',
                borderRadius: '1.2rem',
                background: '#fff',
                margin: '0 auto',
              }
            : {}
        }
      >
      <label style={{width:'400px', fontSize:'16px', color:'rgba(75, 75, 75, 1)', lineHeight:'150%'}}> Username</label>
       
      <input
          type="text"
          name="user_name"
          placeholder="Username"
          value={credentials.user_name}
          onChange={handleChange}
          required
          style={{
            width: '100%',
            height: '53px',
            opacity: 1,
            borderRadius: '8px',
            padding: '16px',
            borderWidth: '1px',
            border: '1px solid rgba(221, 221, 221, 1)',
            fontSize: '16px',
            outline: 'none',
            transition: 'border-color 0.2s',
            boxSizing: 'border-box',
            marginBottom: 12
          }}
          className="focus:border-teal-500"
        />
        <label style={{fontSize:'16px', color:'rgba(75, 75, 75, 1)', lineHeight:'150%'}}> Password</label>
        <div className="relative w-full mb-4">
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder="Password"
            value={credentials.password}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              height: '53px',
              opacity: 1,
              borderRadius: '8px',
              padding: '16px',
              paddingRight: '48px',
              borderWidth: '1px',
              border: '1px solid rgba(221, 221, 221, 1)',
              fontSize: '16px',
              outline: 'none',
              transition: 'border-color 0.2s',
              boxSizing: 'border-box',
              marginBottom: 12
            }}
            className="focus:border-teal-500"
          />
           <span
             style={{
               position: 'absolute',
               right: '16px',
               top: '45%',
               transform: 'translateY(-50%)',
               color: '#6b7280',
               cursor: 'pointer',
               transition: 'color 0.2s'
             }}
             onClick={() => setShowPassword((prev) => !prev)}
             aria-label={showPassword ? 'Hide password' : 'Show password'}
             tabIndex={0}
           >
             {showPassword ? <FiEye size={20} /> : <FiEyeOff size={20} />}
           </span>
         </div>
        <div style={{width: '100%', marginBottom: 16}}>
          <button 
            type="submit" 
            disabled={loading} 
            className={`text-white font-semibold transition-all duration-300 w-full ${
              loading 
                ? 'opacity-80 cursor-not-allowed' 
                : 'hover:opacity-90'
            }`}
            style={{
              width: '100%',
              height: '40px',
              opacity: 1,
              borderRadius: '8px',
              background: 'rgba(15, 150, 144, 1)',
              border: 'none',
              outline: 'none',
              fontSize: 16,
              fontWeight: 600
            }}
          >
            {loading ? (
              <span className="inline-block w-5 h-5 border-2 border-white border-t-blue-500 rounded-full animate-spin"></span>
            ) : (
              'LOGIN'
            )}
          </button>
        </div>
        {status && (
          <p className="mt-4 text-center text-sm text-gray-600">{status}</p>
        )}
      </form>

      {showForgotModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <ForgotPasswordModal onClose={() => setShowForgotModal(false)} />
        </div>
      )}
    </div>
  );
}
  
